<template>
    <div class="bg-dark-primary print:hidden z-50 w-[30px] flex flex-row items-center">
        <RightSideBarCloseSVG class="h-10" @click="toggleRightSideBar" />
    </div>

</template>

<script setup>
import { defineEmits } from 'vue';
import { useStore } from 'vuex';
import RightSideBarCloseSVG from '@/components/svg-components/CloseRightSideBarSVG.vue';

const store = useStore()

const toggleRightSideBar = () => {
    if(!store.getters['showRightSideBar']) {
        store.dispatch('setShowRightSideBarTrue');
    } else {
        store.dispatch('setShowRightSideBarFalse');
    }
}
</script>